export default "__VITE_ASSET__73da925b__"